// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .payment-status {
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
    }

    .payment-status__card {
      width: 100%;
      max-width: 28rem;
      padding: 24px;
      border-radius: 24px;
      background: #ffffff;
      box-shadow: 0 20px 50px rgba(15, 23, 42, 0.12);
      text-align: center;
    }

    .payment-status__icon {
      width: 72px;
      height: 72px;
      margin: 0 auto 16px;
      border-radius: 9999px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      color: #ffffff;
    }

    .payment-status__icon--success {
      background: #16a34a;
    }

    .payment-status__icon--error {
      background: #dc2626;
    }

    .payment-status__card h1 {
      margin: 0 0 12px;
      font-size: 1.5rem;
      font-weight: 700;
      color: #0f172a;
    }

    .payment-status__card p {
      margin: 0 0 20px;
      color: #475569;
      line-height: 1.6;
    }

    .payment-status__actions {
      display: grid;
      gap: 12px;
      margin-top: 20px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/pages/stripe-payment-status/stripe-payment-status.component.ts"],"names":[],"mappings":";IACI;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,aAAa;MACb,6DAA6D;IAC/D;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,8CAA8C;MAC9C,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,qBAAqB;MACrB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,SAAS;MACT,gBAAgB;IAClB","sourcesContent":["\n    .payment-status {\n      min-height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 24px;\n      background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);\n    }\n\n    .payment-status__card {\n      width: 100%;\n      max-width: 28rem;\n      padding: 24px;\n      border-radius: 24px;\n      background: #ffffff;\n      box-shadow: 0 20px 50px rgba(15, 23, 42, 0.12);\n      text-align: center;\n    }\n\n    .payment-status__icon {\n      width: 72px;\n      height: 72px;\n      margin: 0 auto 16px;\n      border-radius: 9999px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 700;\n      color: #ffffff;\n    }\n\n    .payment-status__icon--success {\n      background: #16a34a;\n    }\n\n    .payment-status__icon--error {\n      background: #dc2626;\n    }\n\n    .payment-status__card h1 {\n      margin: 0 0 12px;\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: #0f172a;\n    }\n\n    .payment-status__card p {\n      margin: 0 0 20px;\n      color: #475569;\n      line-height: 1.6;\n    }\n\n    .payment-status__actions {\n      display: grid;\n      gap: 12px;\n      margin-top: 20px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
